import HttpAPICall from './HttpAPICall';
import { ORG_API_BASE_URL_2 } from './TapApiUrls';

let cachedNotifications = [];
let cachedUnreadCount = 0;
let isDataFetched = false;
let isFetching = false;

export const fetchNotifications = (access_token, onComplete, refresh = false) => {
    if (refresh) {
        isDataFetched = false;
    }

    if (!refresh && isDataFetched) {
        onComplete(cachedNotifications, cachedUnreadCount);
        return;
    }

    if (isFetching) {
        const interval = setInterval(() => {
            if (!isFetching) {
                clearInterval(interval);
                onComplete(cachedNotifications, cachedUnreadCount);
            }
        }, 100);
        return;
    }

    isFetching = true;
    const notificationUrl = ORG_API_BASE_URL_2 + "/log/notification/list";
    const params = { page: 1, per_page: "10" };

    HttpAPICall.withAthorization("GET", notificationUrl, access_token, params, {}, (response) => {
        if (response?.data) {
            const respData = response.data;
            cachedNotifications = Array.isArray(respData.data?.data) ? respData.data?.data : [];
            cachedUnreadCount = respData.unread_count || 0;
            isDataFetched = true;
        } else {
            cachedNotifications = [];
            cachedUnreadCount = 0;
            isDataFetched = true;
        }
        isFetching = false;
        onComplete(cachedNotifications, cachedUnreadCount);
    }).catch((err) => {
        cachedNotifications = [];
        cachedUnreadCount = 0;
        isDataFetched = true;
        isFetching = false;
        onComplete(cachedNotifications, cachedUnreadCount);
    });
};

export const getCachedData = () => {
    return {
        notifications: [...cachedNotifications],
        unreadCount: cachedUnreadCount,
        isFetched: isDataFetched
    };
};

export const markReadAndRefresh = (id, currentStatus, access_token, onComplete) => {
    const notificationReadUrl = ORG_API_BASE_URL_2 + "/log/notification/read";
    const payload = {
        id: id,
        is_read: currentStatus === 1 ? 0 : 1
    };

    HttpAPICall.withAthorization("PUT", notificationReadUrl, access_token, {}, payload, (response) => {
        if (response) {
            fetchNotifications(access_token, (notifications, count) => {
                onComplete(true, notifications, count);
            }, true);
        } else {
            onComplete(false, cachedNotifications, cachedUnreadCount);
        }
    }).catch((err) => {
        onComplete(false, cachedNotifications, cachedUnreadCount);
    });
};
export const resetNotificationCache = () => {
    cachedNotifications = [];
    cachedUnreadCount = 0;
    isDataFetched = false;
    isFetching = false;
};